import React, { useContext } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import ExitIcon from '@material-ui/icons/PowerSettingsNew';

import { getLogoutUrlRequest } from '../reducers/Auth/actions';

const LogoutButton = props => {
  const { context } = props;
  const store = useContext(context);
  const state = store.getState();
  const { settings } = state;

  return (
    <MenuItem onClick={() => store.dispatch(getLogoutUrlRequest({ settings }))}>
      <ExitIcon />
      Logout
    </MenuItem>
  );
};

export default LogoutButton;
